import { render, staticRenderFns } from "./foreignExchangeReserve.vue?vue&type=template&id=dc5a8376&scoped=true"
import script from "./foreignExchangeReserve.vue?vue&type=script&lang=js"
export * from "./foreignExchangeReserve.vue?vue&type=script&lang=js"
import style0 from "./foreignExchangeReserve.vue?vue&type=style&index=0&id=dc5a8376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5a8376",
  null
  
)

export default component.exports